import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Lock, Zap, CreditCard, ArrowRight } from 'lucide-react';
import { CountdownTimer, CTAButton } from './Shared';
import { trackInitiateCheckout } from '../utils/pixel';
const CHECKOUT_PACK_COMPLETO = 'https://profelisto.com.ar/checkouts/cn/hWNC7hCD5CeEA2oC8tF66k54/es-ar?_r=AQABp3JjQRBWTaULfQod0ivn0kG_vCiNT7Fhc7U4lnGgvcY';
const CHECKOUT_SECUNDARIA = 'https://profelisto.com.ar/checkouts/cn/hWNC7hCOc2t7uleS9UMtwyLS/es-ar?_r=AQAB2FW3xUFM4jMh7XLlmdk28YahqSf6p2kh8m0RnM9EwlA';
export function UrgencySection() {
  return <section className="bg-brand-900 text-white py-12 border-b border-brand-800" data-id="element-142">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-143">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 flex items-center justify-center gap-3" data-id="element-144">
          <span data-id="element-145">⏰</span> EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="flex justify-center mb-4" data-id="element-146">
          <CountdownTimer data-id="element-147" />
        </div>

        <p className="text-brand-200 mb-8" data-id="element-148">
          Después sube USD $7.00 y no vuelve a bajar.
        </p>

        <div className="bg-brand-950/50 p-6 rounded-2xl border border-brand-800" data-id="element-149">
          <div className="flex justify-between text-sm font-bold mb-2" data-id="element-150">
            <span data-id="element-151">Cupos al precio de lanzamiento:</span>
            <span className="text-amber-400" data-id="element-152">68% tomados</span>
          </div>
          <div className="w-full bg-brand-900 rounded-full h-4 mb-6 overflow-hidden" data-id="element-153">
            <div className="bg-gradient-to-r from-amber-500 to-amber-300 h-4 rounded-full animate-progress" style={{
            width: '68%'
          }} data-id="element-154"></div>
          </div>

          <CTAButton className="w-full" href={CHECKOUT_PACK_COMPLETO} data-id="element-155">
            → ASEGURAR MI PRECIO AHORA
          </CTAButton>
        </div>
      </div>
    </section>;
}
export function PricingSection() {
  const handlePackCompletoClick = () => {
    trackInitiateCheckout({
      content_name: 'CTA — Pack Completo'
    });
    window.open(CHECKOUT_PACK_COMPLETO, '_blank', 'noopener,noreferrer');
  };
  const handleSecundariaClick = () => {
    trackInitiateCheckout({
      content_name: 'CTA — Ciudadanía Secundaria'
    });
    window.open(CHECKOUT_SECUNDARIA, '_blank', 'noopener,noreferrer');
  };
  return <section id="pricing" className="py-10 md:py-20 bg-slate-50 scroll-mt-10" data-id="element-156">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-157">
        <div className="text-center mb-6 md:mb-10" data-id="element-158">
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-2 md:mb-3" data-id="element-159">
            Elegí tu Ciudadanía Pack:
          </h2>
          <p className="text-sm md:text-lg text-slate-600" data-id="element-160">
            Todas las opciones incluyen los 6 bonus estratégicos
          </p>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-161">
          {/* Row 1: Secundaria */}
          <button onClick={handleSecundariaClick} className="w-full text-left bg-white rounded-2xl p-4 md:p-5 border border-slate-200 shadow-sm hover:shadow-md hover:border-slate-300 transition-all flex items-center gap-3 md:gap-4" data-id="element-162">
            <div className="shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 border-slate-300 bg-white" data-id="element-163"></div>
            <div className="flex-1 min-w-0" data-id="element-164">
              <div className="font-extrabold text-sm md:text-base text-slate-900 mb-1" data-id="element-165">
                📗 CIUDADANÍA SECUNDARIA
              </div>
              <p className="text-xs md:text-sm text-slate-600 leading-snug" data-id="element-166">
                6 tomos + 66 actividades + 6 bonus
              </p>
            </div>
            <div className="text-right shrink-0" data-id="element-167">
              <div className="text-[11px] md:text-sm text-slate-400 line-through leading-none" data-id="element-168">
                USD $34.90
              </div>
              <div className="text-lg md:text-2xl font-black text-slate-900 leading-tight" data-id="element-169">
                USD $13.90
              </div>
            </div>
          </button>

          {/* Row 2: Pack Completo (featured) */}
          <button onClick={handlePackCompletoClick} className="w-full text-left bg-amber-50 rounded-2xl p-4 md:p-5 border-2 border-amber-400 shadow-sm hover:shadow-md transition-shadow flex items-center gap-3 md:gap-4" data-id="element-170">
            <div className="shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 border-amber-500 bg-amber-500 flex items-center justify-center" data-id="element-171">
              <div className="w-2 h-2 md:w-2.5 md:h-2.5 rounded-full bg-white" data-id="element-172"></div>
            </div>
            <div className="flex-1 min-w-0" data-id="element-173">
              <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-1" data-id="element-174">
                <span className="font-extrabold text-sm md:text-base text-slate-900" data-id="element-175">
                  🏆 PACK COMPLETO
                </span>
                <span className="inline-flex items-center gap-1 bg-amber-400 text-slate-900 text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-176">
                  ⭐ MÁS ELEGIDO
                </span>
                <span className="hidden sm:inline text-[10px] md:text-xs font-bold text-amber-700 whitespace-nowrap" data-id="element-177">
                  AHORRÁS USD $15.00
                </span>
              </div>
              <p className="text-xs md:text-sm text-slate-600 leading-snug" data-id="element-178">
                6 tomos + 66 actividades + 6 bonus + 2 Ebooks Élite
              </p>
            </div>
            <div className="text-right shrink-0" data-id="element-179">
              <div className="text-[11px] md:text-sm text-slate-400 line-through leading-none" data-id="element-180">
                USD $49.90
              </div>
              <div className="text-lg md:text-2xl font-black text-amber-600 leading-tight" data-id="element-181">
                USD $19.90
              </div>
            </div>
          </button>
        </div>

        {/* Primary CTA */}
        <div className="mt-5 md:mt-8 flex flex-col items-center" data-id="element-182">
          <CTAButton className="w-full md:w-auto py-4 md:py-5 text-base md:text-lg md:px-10" href={CHECKOUT_PACK_COMPLETO} data-id="element-183">
            SÍ, QUIERO PACK COMPLETO →
          </CTAButton>
          <div className="mt-5 md:mt-6 flex justify-center" data-id="element-184">
            <p className="text-xs md:text-sm text-slate-600 font-medium text-center" data-id="element-185">
              💱 Pagarás en tu moneda local · Conversión automática desde USD
            </p>
          </div>
          <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-slate-600 font-medium" data-id="element-186">
            <span className="flex items-center gap-1.5" data-id="element-187">🔒 Pago seguro</span>
            <span className="flex items-center gap-1.5" data-id="element-188">
              ⚡ Acceso en 5 min
            </span>
            <span className="flex items-center gap-1.5" data-id="element-189">
              🛡️ Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-190">
              💳 Tarjeta · PayPal
            </span>
          </div>
        </div>
      </div>
    </section>;
}
export function PackCompletoDetail() {
  return <section className="py-12 bg-white" data-id="element-191">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-192">
        <div className="bg-brand-900/80 rounded-3xl p-8 md:p-12 text-white shadow-2xl relative overflow-hidden" data-id="element-193">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-800 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/3" data-id="element-194"></div>

          <div className="relative z-10" data-id="element-195">
            <div className="inline-block bg-amber-400 text-slate-900 text-xs font-bold px-3 py-1 rounded-full mb-6 uppercase tracking-wider" data-id="element-196">
              LA OPCIÓN MÁS ELEGIDA POR DOCENTES DE SECUNDARIA
            </div>

            <h2 className="text-3xl font-bold mb-8" data-id="element-197">PACK COMPLETO INCLUYE:</h2>

            <div className="grid md:grid-cols-2 gap-4 mb-10" data-id="element-198">
              {['6 tomos completos', '66 actividades con secuencia', '1° a 3° año secundaria', 'Solucionarios incluidos', '6 Bonus estratégicos', 'Planificación Anual lista (Ebook Élite 1)', 'Proyectos ESI + EAI listos para firmar (Ebook Élite 2)', 'Acceso inmediato PDF'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-199">
                  <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" data-id="element-200" />
                  <span className="font-medium text-slate-100" data-id="element-201">{item}</span>
                </div>)}
            </div>

            <div className="flex flex-col md:flex-row items-center justify-between gap-6 bg-brand-950/50 p-6 rounded-2xl border border-brand-800" data-id="element-202">
              <div className="text-2xl font-bold" data-id="element-203">Solo por USD $19.90</div>
              <CTAButton className="w-full md:w-auto" href={CHECKOUT_PACK_COMPLETO} data-id="element-204">
                → QUIERO MI PACK COMPLETO AHORA
              </CTAButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function GuaranteeSection() {
  return <section className="py-20 bg-slate-50" data-id="element-205">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-206">
        <div className="bg-white border-2 border-slate-200 rounded-3xl p-8 md:p-12 text-center shadow-xl" data-id="element-207">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-208">
            <ShieldCheck className="w-10 h-10 text-green-600" data-id="element-209" />
          </div>

          <div className="inline-block bg-slate-100 text-slate-600 font-bold px-4 py-1.5 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-210">
            🛡️ GARANTÍA CIUDADANÍA PACK — 7 DÍAS
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8" data-id="element-211">
            Tu inversión está 100% protegida
          </h2>

          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-12 mb-10 text-lg font-medium text-slate-700" data-id="element-212">
            <div className="flex items-center justify-center gap-2" data-id="element-213">
              <span className="bg-brand-100 text-brand-700 w-8 h-8 rounded-full flex items-center justify-center font-bold" data-id="element-214">
                1
              </span>
              Abrís los 6 tomos.
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-215">
              <span className="bg-brand-100 text-brand-700 w-8 h-8 rounded-full flex items-center justify-center font-bold" data-id="element-216">
                2
              </span>
              Revisás los 6 bonus.
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-217">
              <span className="bg-brand-100 text-brand-700 w-8 h-8 rounded-full flex items-center justify-center font-bold" data-id="element-218">
                3
              </span>
              Los usás en el aula si querés.
            </div>
          </div>

          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 max-w-2xl mx-auto mb-8" data-id="element-219">
            <p className="font-bold text-slate-900 mb-4 text-lg" data-id="element-220">
              Si en 7 días no es lo que esperabas:
            </p>
            <ul className="space-y-2 text-slate-600 text-left max-w-xs mx-auto" data-id="element-221">
              <li className="flex items-center gap-2" data-id="element-222">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-223" /> Te
                devolvemos el 100%.
              </li>
              <li className="flex items-center gap-2" data-id="element-224">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-225" /> Sin
                preguntas.
              </li>
              <li className="flex items-center gap-2" data-id="element-226">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-227" /> Sin
                formularios.
              </li>
              <li className="flex items-center gap-2" data-id="element-228">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-229" /> Sin drama.
              </li>
            </ul>
          </div>

          <p className="text-slate-500 font-medium" data-id="element-230">
            La confianza que tenemos en el Ciudadanía Pack nos permite ofrecerte
            eso.
            <br data-id="element-231" />
            Más de 1.200 docentes ya lo saben.
          </p>
        </div>
      </div>
    </section>;
}
export function ExtendedTestimonials() {
  const testimonials = [{
    avatar: 'PN',
    name: 'Paula N.',
    loc: '📍 Ciudad de México, México | Docente de Ciudadanía Secundaria',
    quote: 'Lo bajé un sábado a la tarde y para el lunes ya tenía el primer trimestre cerrado, tomo por tomo y año por año. Las propuestas obligan a los pibes a pensar de verdad, no son para tapar agujeros de hora.'
  }, {
    avatar: 'JM',
    name: 'Julieta M.',
    loc: '📍 Madrid, España | Docente de Ciudadanía',
    quote: 'Lo que me voló la cabeza fueron el ESI y el EAI ya escritos. Los entregué firmados en la primera reunión y la vice me preguntó si los había mandado a hacer. Le dije que los había trabajado yo. Casi no mentí.'
  }, {
    avatar: 'NF',
    name: 'Nicolás F.',
    loc: '📍 Bogotá, Colombia | Docente de Ciudadanía',
    quote: 'Lo que me ganó es que está dividido POR AÑO Y POR EJE TEMÁTICO. No tengo que estar adivinando qué le toca a 1°, a 2° o a 3°. Viene todo secuenciado y listo para llevar al aula.'
  }, {
    avatar: 'AM',
    name: 'Agustina M.',
    loc: '📍 Lima, Perú | Docente de Ciudadanía Secundaria',
    quote: 'Pensé que iba a ser otro material genérico bajado de internet. Desde la primera clase me di cuenta que está hecho para la escuela argentina real: cursos de 35 pibes, dos módulos por semana y poco presupuesto.'
  }, {
    avatar: 'GA',
    name: 'Gabriela A.',
    loc: '📍 Santiago, Chile | Docente de Ciudadanía',
    quote: 'Mis alumnos de 2° año arrancan a debatir solos apenas pongo el disparador. Los temas del Banco Express son oro puro. Se terminó el silencio incómodo de mirar al techo.'
  }, {
    avatar: 'EH',
    name: 'Esteban H.',
    loc: '📍 Montevideo, Uruguay | Docente de Ciudadanía',
    quote: 'Por primera vez en 15 años de aula presenté la planificación anual completa el primer día de marzo. Nunca me había pasado. Me sacó un peso enorme de encima con la parte administrativa.'
  }];
  return <section className="py-20 bg-white" data-id="element-232">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-233">
        <div className="text-center mb-16" data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-235">
            Lo que dicen los docentes de Ciudadanía que ya tienen su Pack:
          </h2>
          <p className="text-xl text-brand-600 font-medium" data-id="element-236">
            +1.200 docentes en el Mundo ya lo usan
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-237">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-50 p-6 rounded-2xl border border-slate-200 flex flex-col" data-id="element-238">
              <div className="flex gap-1 mb-4" data-id="element-239">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-240" />)}
              </div>
              <p className="text-slate-700 italic mb-6 flex-1" data-id="element-241">"{t.quote}"</p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-slate-200" data-id="element-242">
                <div className="w-10 h-10 bg-brand-100 text-brand-700 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-243">
                  {t.avatar}
                </div>
                <div data-id="element-244">
                  <div className="font-bold text-slate-900 text-sm" data-id="element-245">
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-246">{t.loc}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
// Helper icon for ExtendedTestimonials
function StarIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-247">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" data-id="element-248"></path>
      <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" fill="currentColor" data-id="element-249"></path>
    </svg>;
}